var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ColorLegend from "../components/colorlegend.vue";
import Gltf from "../components/gltf.vue";
import { createSvg, } from "./utilities/aux";
let ExpandedGeometry = class ExpandedGeometry extends Vue {
    close() { }
    get geometryColors() {
        return [
            "green",
            "cyan",
            "red",
        ];
    }
    mounted() {
        if (this.geometry.tag === "svg") {
            this.currentSvg = createSvg(this.geometry.svg);
            const s = this.$el.querySelector(".expanded-svg");
            if (s === undefined || s === null) {
                throw Error("Selector '.expanded-svg' does not match");
            }
            s.appendChild(this.currentSvg);
        }
    }
};
__decorate([
    Prop({ required: true })
], ExpandedGeometry.prototype, "geometry", void 0);
__decorate([
    Prop({ required: true })
], ExpandedGeometry.prototype, "problematicGeometries", void 0);
__decorate([
    Prop({ required: true })
], ExpandedGeometry.prototype, "bendPart", void 0);
__decorate([
    Inject()
], ExpandedGeometry.prototype, "i18n", void 0);
__decorate([
    Emit()
], ExpandedGeometry.prototype, "close", null);
ExpandedGeometry = __decorate([
    Component({
        components: {
            ColorLegend,
            Gltf,
        },
        name: "ExpandedGeometry",
    })
], ExpandedGeometry);
export default ExpandedGeometry;
